import MojitoCore from 'mojito/core';

import {Logger} from '#core/utils/logger.js';
import {getAllParamsFromURL} from '#core/utils/url-utils.js';
import {DATA_TYPE, parseBool, parseInteger, parseNumber, parseString} from '#core/utils/data-validation.cjs';

import {WidgetsProviderService} from '#core/application/widgets-provider/index.js';

const {UIViewImplementation} = MojitoCore.Presentation;

const PARAMS_PARSERS_MAP = {
    [DATA_TYPE.BOOL]: parseBool,
    [DATA_TYPE.INT]: parseInteger,
    [DATA_TYPE.NUMBER]: parseNumber,
    [DATA_TYPE.STRING]: parseString,
};

const log = Logger('AbstractWidget');

function getParsedParams(params = {}, paramsSchema = {}) {
    return Object.keys(params).reduce((acc, key) => {
        const errorPrefix = `Parameter "${key}" parsing error`;
        const parser = PARAMS_PARSERS_MAP[paramsSchema[key]];

        if (!parser) {
            log.warn(`${errorPrefix}: unknown type "${paramsSchema[key]}"`);

            return acc;
        }

        const parsedResult = parser(params[key], false, undefined, `getParsedParams::${key}`);

        if (parsedResult.error) {
            log.warn(`${errorPrefix}: ${parsedResult.error}`);

            return acc;
        }

        return {
            ...acc,
            [key]: parsedResult.value,
        };
    }, {});
}

export default class AbstractWidget extends UIViewImplementation {
    constructor(props) {
        super(props);

        const rawParams = WidgetsProviderService.isFullscreenWidget() ? getAllParamsFromURL() : props.params;

        this.params = getParsedParams(rawParams, this.constructor.paramsTypes);
    }
}
